<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pXI"></a><span class="fsc">ACKNOWLEDGEMENTS</span></p>
<p class="ftxt"><span class="dropcap">T</span><span class="fsc">HERE ARE SO VERY</span> many people who have been incredibly helpful in the process of writing this book. First on that list are my very patient editors at Yale University Press, Heather McCallum and Rachael Lonsdale. I also valued the comments of the anonymous readers who provided a great deal of clarity, useful observations and encouragement, as well as pointing out many errors, problems and omissions. Any left are mine alone. My good friends and colleagues Sandra Bingham and Stephen Copp have helped in the creation of this story in so many ways, including very practical ones. My students at the University of Reading who took the ‘Carthage’ module and had many ideas, thoughts and comments that helped to focus my thinking on the topic of Hannibal in the final stages of the book. There are also many other good friends, family (often both) and colleagues who have always been willing to encourage and listen when I am sure there were better things to consider than Hannibal – again many thanks. The greatest thanks of all must go to my husband, Keith Tracey, whose patience, editorial skills and even more patience helped to make this a much better work.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?0a992327